import { ProgressBar } from "react-bootstrap";

const UploadFileProgress = ({progress}) => {
    return (
        <div className="d-block" 
            style={{
                marginTop:'-2px',
                height:'2px',
                maxHeight:'2px'
            }}>
        {(progress > 0)
        ? (<ProgressBar 
                style={{maxHeight:'2px'}} 
                animated 
                striped 
                variant="primary" 
                now={progress} />)
        : (null) }
        </div>
    )
}

export default UploadFileProgress;